"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getByteLength = getByteLength;
exports.template = template;

/**
 * 获取字符串的字节长度，规定中文（含中文标点）2 个字符，英文数字（含英文标点）1 个字符
 * @returns 字节
 */
function getByteLength(text) {
  if (typeof text !== 'string') return 0;
  return text.replace(/[^\x00-\xff]/g, '**').length;
}
/**
 *
 * 子吐槽替换
 * @export
 * @param {string} str
 * @param {Record<string, any>} [data]
 * @returns
 */


function template(str, data) {
  return str.replace(/\{([0-9a-zA-Z_]+)\}/g, (match, key) => {
    if (data && match && Object.prototype.hasOwnProperty.call(data, key)) {
      return data[key];
    }

    return '';
  });
}